// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__31Q_6","header":"ReportDetails_header__2N1sO","title":"ReportDetails_title__1g3ia","left":"ReportDetails_left__3_o0l"};